import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/historialInventario/importer/historialInventarioImporterActions';

export default importerReducers(actions);
